<template>
  <FullPageLayout>
    <template v-if="fetchState.pending">
      <div>loading...</div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>

    <template v-else>
      <nav v-if="!isMobile" class="w-full bg-white border-b border-divider-[#EAECF1] h-10 u-center sticky top-[100px] z-3">
        <div class="nav--desktop currency-widget w-full flex items-center">
          <!-- Currency Widget -->
          <CurrencyWidget :currencies="feed.widgetMap.currencies" />
        </div>
      </nav>
      <StickyMenu v-if="isMobile" :items="feed" />
      <div class="sm:max-w-[1100px] sm:mx-auto sm:relative sm:space-y-6 space-y-4">
        <AdController unit="masthead" class="my-4 sm:my-6" />
        <template v-if="isMobile">
          <div v-if="IS_ONEDIO" class="u-center">
            <div class="border-t border-[#E2E5ED] flex-grow"></div>
            <OLink class="kesfetText content__all u-center mx-4 font-semibold text-16" href="/kesfet">
              <span class="kesfetBorder px-2" data="Keşfet"></span>
              &nbsp;ile İçeriklerini Seç ve Takip Et!
              <span class="w-[34px] h-[34px] u-center bg-[#9557E4] ml-4 rounded-full">
                <OIcon icon="right-white" />
              </span>
            </OLink>
            <div class="border-t border-[#E2E5ED] flex-grow"></div>
          </div>
          <LazyHydrate :when-visible="{ rootMargin: '100px' }" v-bind="bindDataTbRegionSlider">
            <div class="relative">
              <HomePageSliderArrow direction="prev" />
              <HomePageSliderArrow direction="next" />
              <HomepageSlider :items="headline.slice(7)" class="mb-4" :hp4u-attrs="showHp4uAttrs" />
            </div>
          </LazyHydrate>
          <!-- Currency Widget -->
          <CurrencyWidget :currencies="feed.widgetMap.currencies" />
          <div class="space-y-4" v-bind="bindDataTbRegion2Cards">
            <HomepageSliderCard
              v-for="(article, index) in headline.slice(0, 2)"
              :key="article._id"
              class="bg-white"
              :article="article"
              variant="left"
              :data-layer="{ name: 'Anasayfa - Manşet - Sol Menü', position: index + 1 }"
              v-bind="bindDataTbRegionItem"
              :hp4u-attrs="showHp4uAttrs"
            />
          </div>
          <div class="space-y-4" v-bind="bindDataTbRegion5Cards">
            <HomepageSliderCard
              v-for="(article, index) in headline.slice(2, 7)"
              :key="article._id"
              class="bg-white"
              :article="article"
              variant="right"
              :device-style="{ mobile: 'height: 90px;' }"
              :data-layer="{ name: 'Anasayfa - Manşet - Sağ Menü', position: index + 1 }"
              v-bind="bindDataTbRegionItem"
              :hp4u-attrs="showHp4uAttrs"
            />
          </div>
          <div class="bg-white u-center p-9">
            <AdController unit="mansetalti" />
          </div>
        </template>
        <template v-else>
          <div v-if="IS_ONEDIO" class="u-center">
            <div class="border-t border-[#E2E5ED] flex-grow"></div>
            <OLink class="kesfetText content__all u-center mx-4 font-semibold text-20" href="/kesfet">
              <span class="kesfetBorder px-2" data="Keşfet"></span>
              &nbsp;ile İçeriklerini Seç ve Takip Et!
              <span class="w-[34px] h-[34px] u-center bg-[#9557E4] ml-4 rounded-full">
                <OIcon icon="right-white" />
              </span>
            </OLink>
            <div class="border-t border-[#E2E5ED] flex-grow"></div>
          </div>
          <div class="flex space-x-4">
            <div class="space-y-4" v-bind="bindDataTbRegion2Cards">
              <HomepageSliderCard
                v-for="(article, index) in headline.slice(0, 2)"
                :key="article._id"
                class="bg-white"
                :article="article"
                variant="left"
                :device-style="{ desktop: 'width: 204px; height: 225px;' }"
                :data-layer="{ name: 'Anasayfa - Manşet - Sol Menü', position: index + 1 }"
                v-bind="bindDataTbRegionItem"
                :hp4u-attrs="showHp4uAttrs"
              />
            </div>
            <LazyHydrate :when-visible="{ rootMargin: '100px' }" v-bind="bindDataTbRegionSlider">
              <div class="relative">
                <HomePageSliderArrow direction="prev" />
                <HomePageSliderArrow direction="next" />
                <HomepageSlider :items="headline.slice(7)" :hp4u-attrs="showHp4uAttrs" />
              </div>
            </LazyHydrate>
            <div class="space-y-4" v-bind="bindDataTbRegion5Cards">
              <HomepageSliderCard
                v-for="(article, index) in headline.slice(2, 7)"
                :key="article._id"
                class="bg-white"
                :article="article"
                variant="right"
                :device-style="{ desktop: 'width: 333px; height: 80px;' }"
                :data-layer="{ name: 'Anasayfa - Manşet - Sağ Menü', position: index + 1 }"
                v-bind="bindDataTbRegionItem"
                :hp4u-attrs="showHp4uAttrs"
              />
            </div>
          </div>
          <AdController unit="mansetalti" />
        </template>
        <div v-for="(item, index) in feed.config.components" :key="item.widgets[0].id" class="sm:space-y-6 space-y-4">
          <div class="flex w-full space-x-6">
            <div v-for="widget in item.widgets" :key="widget.id" class="w-full">
              <div :id="widget.id + '-start'" class="homepage-widget-observer" />
              <ArticleWidget
                v-if="widget.type === 'cards_6' || widget.type === 'cards_10'"
                :data="feed.widgetMap[widget.id]"
                :widget-index="index"
              />
              <LazyHydrate :when-visible="{ rootMargin: '100px' }">
                <HorizontalSliderWidget v-if="widget.type === 'slider' && widget.id !== 'videos'" :data="feed.widgetMap[widget.id]" />
              </LazyHydrate>
              <LazyHydrate :when-visible="{ rootMargin: '100px' }">
                <VideosWidget v-if="widget.id === 'videos'" :data="feed.widgetMap[widget.id]" />
              </LazyHydrate>
              <LazyHydrate :when-visible="{ rootMargin: '100px' }">
                <HoroscopeWidget v-if="widget.type === 'astrology'" :data="feed.widgetMap[widget.id]" />
              </LazyHydrate>
              <LazyHydrate :when-visible="{ rootMargin: '100px' }">
                <HashtagWidget v-if="widget.type === 'hashtag'" :hashtags="feed.widgetMap[widget.id]" />
              </LazyHydrate>
              <LazyHydrate :when-visible="{ rootMargin: '100px' }">
                <YazioSliderWidget v-if="widget.type === 'yazio'" :authors="feed.widgetMap[widget.id]" />
              </LazyHydrate>
              <LazyHydrate :when-visible="{ rootMargin: '100px' }">
                <LeaderboardWidget v-if="widget.type === 'leaderboard'" :data="feed.widgetMap[widget.id]" />
              </LazyHydrate>
              <LazyHydrate :when-visible="{ rootMargin: '100px' }">
                <GameSliderWidget v-if="widget.type === 'games'" :data="feed.widgetMap[widget.id]" />
              </LazyHydrate>
              <VitrinWidget v-if="widget.type === 'vitrin'" :articles="feed.widgetMap[widget.id]" class="sm:min-w-[652px]" />
              <DioWidget v-if="widget.type === 'dio'" :data="feed.widgetMap[widget.id]" />
              <div :id="widget.id + '-end'" class="homepage-widget-observer" />
            </div>
          </div>
          <AdController :key="`${item.widgets[0].id}_${isMobile ? 'mobile' : 'desktop'}_ad`" unit="mastheadler" :parent-index="index" />
        </div>
      </div>
      <AdController unit="bodyBottom" />
    </template>
  </FullPageLayout>
</template>

<script>
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import { defineComponent, onMounted, useFetch, useMeta, useContext, toRefs, watch, reactive, onUnmounted } from '@nuxtjs/composition-api';
import AdController from '@/modules/ads/components/AdController';
import { initializeAdLoaders } from '@/modules/ads/adUtils';
import LazyHydrate from 'vue-lazy-hydration';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import HomepageSliderCard from '@/modules/card/templates/homepage/SliderCard';
import ArticleWidget from '@/modules/homepage/components/ArticleWidget';
import { useFeedMeta } from '~/modules/feed/utils/feedMeta';
import { useDevice } from '~/composables/useDevice';
import VitrinWidget from '~/modules/homepage/components/VitrinWidget';
import DioWidget from '~/modules/homepage/components/DioWidget';
import { CAREER_LOG } from '~/constants/site';
import CurrencyWidget from '~/modules/homepage/components/CurrencyWidget.vue';
import StickyMenu from '~/modules/homepage/components/StickyMenu.vue';
import { IS_ONEDIO } from '~/constants/config';
import VideosWidget from '~/modules/homepage/components/VideosWidget/VideosWidget.vue';
import { OLink, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  head: {
    bodyAttrs: {
      class: 'bg-[#f7f8fb] o-ps-global',
    },
  },
  components: {
    LazyHydrate,
    FullPageLayout,
    ErrorPageLayout,
    AdController,
    HomepageSliderCard,
    VitrinWidget,
    DioWidget,
    HorizontalSliderWidget: () =>
      import(/* webpackChunkName: "HorizontalSliderWidget" */ '~/modules/homepage/components/HorizontalSliderWidget'),
    YazioSliderWidget: () => import(/* webpackChunkName: "YazioSliderWidget" */ '~/modules/homepage/components/YazioSliderWidget'),
    GameSliderWidget: () => import(/* webpackChunkName: "GameSliderWidget" */ '~/modules/homepage/components/GameSliderWidget'),
    LeaderboardWidget: () => import(/* webpackChunkName: "LeaderboardWidget" */ '~/modules/homepage/components/LeaderboardWidget'),
    HomepageSlider: () => import(/* webpackChunkName: "HomepageSlider" */ '~/modules/sliders/components/homepage/HomepageSlider'),
    HomePageSliderArrow: () =>
      import(/* webpackChunkName: "HomePageSliderArrow" */ '~/modules/sliders/components/homepage/HomePageSliderArrow'),
    ArticleWidget,
    HoroscopeWidget: () => import(/* webpackChunkName: "HoroscopeWidget" */ '~/modules/homepage/components/HoroscopeWidget'),
    HashtagWidget: () => import(/* webpackChunkName: "HashtagWidget" */ '~/modules/homepage/components/HashtagWidget'),
    CurrencyWidget,
    StickyMenu,
    VideosWidget,
    OLink,
    OIcon,
  },
  setup() {
    const { $error, i18n, $service, $cache } = useContext();
    const { isMobile } = useDevice();
    const homepageState = reactive({
      headline: [],
      headlineMobile: [],
      feed: {},
    });

    const { generateAdConfig } = initializeAdLoaders();
    const serversideAdConfig = generateAdConfig('Homepage');

    // ------- Google Pageview Event Beginning -------
    const { sendPageviewEvent } = useTracking();
    sendPageviewEvent({
      page: {
        type: 'Anasayfa', // Sayfa tipine göre bu değer gelmelidir.
      },
    });
    // ------- Google Pageview Event End -------

    $cache('public, max-age=30');

    const { fetch, fetchState } = useFetch(async () => {
      try {
        const { data } = await $service.homepage.getHomePageData({ platform: isMobile.value ? 'mobile' : 'desktop' });
        homepageState.feed = data;
        homepageState.headline = homepageState.feed.widgetMap?.headlines?.data;
        serversideAdConfig();
      } catch (error) {
        $error(error);
      }
    });
    let intervalId;
    const autoFetch = () => {
      intervalId = setInterval(async () => {
        await fetch();
      }, 1000 * 60 * 5);
    };

    // Watch for changes in the isMobile state and fetch the homepage data again
    watch(isMobile, async () => {
      await fetch();
    });

    const handleStickyMenu = () => {
      const stickyMenu = document.querySelector('.sticky-menu');
      const mediaFooter = document.querySelector('.media-footer');
      if (stickyMenu) {
        mediaFooter.style.paddingBottom = '64px';
      }
    };

    onMounted(() => {
      // eslint-disable-line
      console.log(CAREER_LOG);
      autoFetch();
      handleStickyMenu();
    });
    onUnmounted(() => {
      clearInterval(intervalId);
    });

    useMeta(() => ({ title: i18n.t('meta.title') }));

    useFeedMeta();

    const showHp4uAttrs = IS_ONEDIO;
    const bindDataTbRegion2Cards = showHp4uAttrs ? { 'data-tb-region': 'Headline2Cards' } : {};
    const bindDataTbRegion5Cards = showHp4uAttrs ? { 'data-tb-region': 'Headline5Cards' } : {};
    const bindDataTbRegionSlider = showHp4uAttrs ? { 'data-tb-region': 'HeadlineSlider' } : {};
    const bindDataTbRegionItem = showHp4uAttrs ? { 'data-tb-region-item': '' } : {};

    return {
      ...toRefs(homepageState),
      fetch,
      fetchState,
      isMobile,
      IS_ONEDIO,
      showHp4uAttrs,
      bindDataTbRegion2Cards,
      bindDataTbRegion5Cards,
      bindDataTbRegionSlider,
      bindDataTbRegionItem,
    };
  },
});
</script>

<style lang="scss" scoped>
.kesfetBorder {
  position: relative;
  border-radius: 8px;
  background-image: linear-gradient(to right, #306aff, #cc4ad4);
  background-origin: border-box;
  box-shadow: inset 0 100vw #f7f8fb;
  border: 2.5px solid transparent;
}
.kesfetBorder::before {
  content: '';
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  left: 1px;
  background-color: #f7f8fb;
  border-radius: 4px;
  z-index: -1;
}
.kesfetBorder::after {
  content: attr(data);
  -webkit-background-clip: text;
  color: #424242;
}
.kesfetText:hover {
  background: -webkit-linear-gradient(#306aff, #cc4ad4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.kesfetText:hover .kesfetBorder::after {
  background: linear-gradient(#306aff, #cc4ad4);
  -webkit-background-clip: text;
  color: transparent;
}

@media (max-width: 390px) {
  .kesfetText {
    font-size: 12px;
  }
}
</style>
